import React from 'react'
import cx from 'classnames'

interface Props {
  align?: 'left' | 'center'
  direction?: 'row' | 'column'
  variant?: 'colored' | 'gradient'
  children: React.ReactNode
}

const ColoredBox = ({
  align = 'left',
  direction = 'column',
  variant = 'gradient',
  children,
}: Props) => {
  return (
    <div className={cx('colored-box', variant, direction, align)}>
      <div className="colored-box-content">{children}</div>
    </div>
  )
}

export default ColoredBox
